// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"0f8a0549","990":"705af9a6"}[chunkId] + ".chunk.js";
};